import { motion } from 'framer-motion'
import Reveal from './Reveal'

const testimonios = [
  {
    initials: 'ML',
    name: 'María Laura G.',
    course: 'Cardiología Clínica Avanzada',
    text: 'El curso fue un antes y un después. Explica de una forma que ningún libro logró. Aprobé la guardia con una seguridad que antes no tenía.',
  },
  {
    initials: 'CR',
    name: 'Carlos R.',
    course: 'Mentoría 1 a 1 · MIR',
    text: 'La mentoría cambió completamente mi enfoque. En 3 meses avancé más que en el año anterior estudiando solo. Vale cada centavo.',
  },
  {
    initials: 'SP',
    name: 'Sofía P.',
    course: 'Farmacología Aplicada',
    text: 'Por fin entiendo el razonamiento detrás de cada prescripción. Recomendable para cualquier médico que quiera pensar mejor.',
  },
]

function Stars() {
  return (
    <div className="flex gap-1 mb-5">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} width="12" height="12" viewBox="0 0 12 12">
          <path
            d="M6 0.5l1.545 3.13 3.455.502-2.5 2.437.59 3.44L6 8.33 2.91 9.91l.59-3.44L1 4.132l3.455-.501z"
            fill="#C9A84C"
          />
        </svg>
      ))}
    </div>
  )
}

// Decorative molecule SVG used as section bg accent
function MoleculeAccent() {
  return (
    <svg
      width="320" height="320" viewBox="0 0 320 320" fill="none"
      className="absolute -bottom-16 -left-16 opacity-[0.03] pointer-events-none"
    >
      <circle cx="160" cy="160" r="120" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="160" cy="160" r="80" stroke="#C9A84C" strokeWidth="0.5"/>
      <circle cx="160" cy="40" r="12" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="160" cy="280" r="12" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="40" cy="160" r="12" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="280" cy="160" r="12" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="75" cy="75" r="8" stroke="#C9A84C" strokeWidth="0.8"/>
      <circle cx="245" cy="75" r="8" stroke="#C9A84C" strokeWidth="0.8"/>
      <circle cx="75" cy="245" r="8" stroke="#C9A84C" strokeWidth="0.8"/>
      <circle cx="245" cy="245" r="8" stroke="#C9A84C" strokeWidth="0.8"/>
      <line x1="160" y1="40" x2="160" y2="280" stroke="#C9A84C" strokeWidth="0.4"/>
      <line x1="40" y1="160" x2="280" y2="160" stroke="#C9A84C" strokeWidth="0.4"/>
      <line x1="75" y1="75" x2="245" y2="245" stroke="#C9A84C" strokeWidth="0.4"/>
      <line x1="245" y1="75" x2="75" y2="245" stroke="#C9A84C" strokeWidth="0.4"/>
    </svg>
  )
}

export default function Testimonios() {
  return (
    <section
      id="testimonios"
      className="relative overflow-hidden"
      style={{ padding: '120px 5vw', background: 'var(--bg)' }}
    >
      <MoleculeAccent />

      <div className="relative z-10">
        <Reveal>
          <div className="section-label">Testimonios</div>
          <h2
            className="font-display font-black leading-[1.04] tracking-[-0.02em] mb-16"
            style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)', color: 'var(--ink)' }}
          >
            Lo que dicen quienes ya<br />
            <em className="not-italic" style={{ color: 'var(--gold)' }}>
              transformaron
            </em>{' '}
            su carrera.
          </h2>
        </Reveal>

        <div
          className="grid grid-cols-1 md:grid-cols-3"
          style={{ gap: '1px', background: 'var(--line)' }}
        >
          {testimonios.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ backgroundColor: 'rgba(22,22,22,1)' }}
              className="flex flex-col justify-between"
              style={{ background: 'var(--bg)', padding: '40px' }}
            >
              <div>
                <Stars />
                <div
                  className="font-display font-black leading-[0.8] mb-3 opacity-30"
                  style={{ fontSize: '40px', color: 'var(--gold)' }}
                >
                  "
                </div>
                <p
                  className="font-body font-light text-[14px] leading-[1.85] italic mb-8"
                  style={{ color: 'var(--ink-2)' }}
                >
                  {t.text}
                </p>
              </div>

              <div
                className="flex items-center gap-3.5 pt-6"
                style={{ borderTop: '1px solid var(--line-2)' }}
              >
                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center shrink-0 font-display font-black text-[11px]"
                  style={{
                    background: 'rgba(201,168,76,0.1)',
                    border: '1px solid var(--line)',
                    color: 'var(--gold)',
                  }}
                >
                  {t.initials}
                </div>
                <div>
                  <div
                    className="font-display font-bold text-[13px]"
                    style={{ color: 'var(--ink)' }}
                  >
                    {t.name}
                  </div>
                  <div
                    className="font-body text-[11px] mt-0.5"
                    style={{ color: 'var(--ink-3)' }}
                  >
                    {t.course}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}